import { useQuery } from '@tanstack/react-query';
import { ReadingsService } from 'src/services/readings/readings.service';

type Item = {
  id: string;
  assignedAlarmTagId?: string | null;
  assignedAlarmGatewayId?: string | null;
};

type Props = {
  items?: Item[];
};

export const useGetMultipleLatestReadings = ({ items }: Props) => {
  const validItems = (items ?? []).filter(
    (item) => !!item.assignedAlarmGatewayId && !!item.assignedAlarmTagId
  );

  const query = useQuery({
    queryKey: ['multipleLatestReadings', validItems],
    queryFn: async () => {
      if (validItems.length === 0) {
        return {};
      }

      const promises = validItems.map((item) =>
        ReadingsService.getLatestReadingsNewDataStorage({
          gatewayId: item.assignedAlarmGatewayId as string,
          measurements: item.assignedAlarmTagId as string,
        })
          .then((res) => (res ? { id: item.id, data: res.data } : null))
          .catch((error) => {
            console.error(`Error fetching data for item ${item.id}`, error);
            return null;
          })
      );

      const results = await Promise.all(promises);

      const dataMap: Record<string, any> = {};
      results.forEach((result) => {
        if (result) {
          dataMap[result.id] = result.data;
        }
      });

      return dataMap;
    },
    enabled: validItems?.length > 0,
    staleTime: 1000 * 60 * 2,
  });

  return {
    readingsMap: query.data ?? {},
    isDataReady: query.isSuccess && !query.isFetching,
  };
};
